<template>
  <div class="home">
    <zlf-search></zlf-search>
    <zlf-list></zlf-list>
  </div>
</template>
<script>
import zlfSearch from './components/zlfSearch.vue'
import zlfList from './components/zlfList.vue'
export default {
  name: 'Home',
  inject: ['reload'],
  data() {
    return {
      keepScroll: 0,
    }
  },
  beforeRouteLeave(to, from, next) {
    // 从列表页去到别的页面，如果不是详情页，则不缓存列表页
    if (
      to.name != 'order' &&
      to.name != 'plaingold' &&
      to.name != 'watch' &&
      to.name != 'goldsetting'
    ) {
      this.$route.meta.keepAlive = false
      this.$route.meta.flag = false
    } else if (
      to.name == 'order' ||
      to.name == 'plaingold' ||
      to.name == 'watch' ||
      to.name == 'goldsetting'
    ) {
      this.$route.meta.keepAlive = true
      this.$route.meta.flag = true
      const scrollTop = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      )
      this.keepScroll = scrollTop
    }
    next()
  },
  components: {
    zlfSearch,
    zlfList,
  },
  methods: {},
  mounted() {},
  activated() {
    var gotoScroll = this.keepScroll
    setTimeout(function() {
      //兼容 PC and Mobile 写两个
      document.body.scrollTop = gotoScroll
      document.documentElement.scrollTop = gotoScroll
    }, 10)
  },
}
</script>
<style scoped>
.home {
  background: #f3f3f3;
}
</style>
